/* Dr.Primal — mobile snap-scroll rails.
   The scrolling itself is CSS (scroll-snap); this file only does what CSS cannot:

   1. Marks a rail that actually overflows, so the "swipe" hint is shown only when
      there is something to swipe to.
   2. Makes an overflowing rail keyboard-operable — a scroll container needs a tab
      stop and an accessible name to be reachable with arrow keys (WCAG 2.2). A rail
      that fits gets neither, so it never becomes a pointless tab stop. */
(function () {
  'use strict';

  function measure(rail) {
    // 1px of tolerance: sub-pixel layout rounding otherwise reports a false overflow.
    var overflows = rail.scrollWidth - rail.clientWidth > 1;

    rail.setAttribute('data-dp-overflow', overflows ? 'true' : 'false');

    if (overflows) {
      rail.setAttribute('tabindex', '0');
      rail.setAttribute('role', 'group');
      var label = rail.getAttribute('data-dp-rail-label');
      if (label) rail.setAttribute('aria-label', label);
    } else {
      rail.removeAttribute('tabindex');
      rail.removeAttribute('role');
      rail.removeAttribute('aria-label');
    }
  }

  function init() {
    var rails = document.querySelectorAll('[data-dp-rail]');
    if (!rails.length) return;

    Array.prototype.forEach.call(rails, function (rail) {
      measure(rail);

      if (rail.getAttribute('data-dp-rail-ready') === 'true') return;
      rail.setAttribute('data-dp-rail-ready', 'true');

      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(function () {
          measure(rail);
        }).observe(rail);
      } else {
        window.addEventListener('resize', function () {
          measure(rail);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
